import { render, staticRenderFns } from "./ArticuloAgregarComponent.vue?vue&type=template&id=3720b356"
import script from "./ArticuloAgregarComponent.vue?vue&type=script&lang=js"
export * from "./ArticuloAgregarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports